import {
    Typography,
    Box,
    Tab,
    Tabs,
    IconButton,
    makeStyles,
} from '@material-ui/core';
import { useEffect, useReducer, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { COLORS } from '../Theme';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    sideHeader: {
        width: '100%',
        height: '100vh',
        maxWidth: '290px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        overflow: 'hidden',
        padding: '40px 0',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    logo: {
        marginTop: '30px',
        padding: '0 40px',
        '& img': {
            width: '100%',
        },
    },
    menuBox: {
        width: '100%',
        minHeight: '82%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '18px',
        color: '#fff',
        fontSize: '18px',
    },
    menu: {
        '& .Mui-selected': {
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: `${COLORS.PUMPKIN}`,
        },
    },
    iconAlignBox: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    IconSize: {
        width: '25px',
        height: '25px',
    },
    linkTab: {
        ...theme.typography.body1,
        fontFamily: 'NanumR',
        padding: 0,
        color: `${COLORS.LIGHT_GREY}`,
        '&:hover': {
            color: `${COLORS.WHITE}`,
        },
    },
}));

function a11yProps(index: any) {
    return {
        id: `nav-tab-${index}`,
        'aria-controls': `nav-tabpanel-${index}`,
    };
}

interface LinkTabProps {
    label?: string;
    href?: string;
    history?: any;
    classNameProps?: any;
    member?: any;
}

function LinkTab(props: LinkTabProps) {
    return (
        <Tab
            component="a"
            onClick={(
                event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
            ) => {
                event.preventDefault();
                props.history.push({
                    pathname: props.href,
                    ...(props.member && {
                        state: {
                            // location state
                            code: props.member.classCode,
                        },
                    }),
                });
            }}
            className={props.classNameProps}
            {...props}
        />
    );
}

// 경영현황 / 연구개발 / 재료구매 / 제품생산 / 제품판매
const address = [
    '/CompanyInfo',
    '/LicenseList',
    '/ProductionList',
    '/MaterialPurchase',
    '/ProductList' /*'/ProductSale'*/,
];
const SideHeader = () => {
    const classes = useStyles();

    const [value, setValue] = useState(setInitValue(window.location.pathname));
    const history = useHistory();

    const goSetting = () => {
        history.push(`/setting`);
    };

    const goQnA = () => {
        history.push(`/qna`);
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        console.log(newValue);
        setValue(newValue);
    };

    function setInitValue(path: string) {
        if (path == '/') return 0;

        return address.findIndex((element) => element == path) || 0;
    }

    const convertPath = (pathName: string) => {
        if (pathName == '/') return 0;
        return address.findIndex((element) => element == pathName);
    };

    const refresh = () => {
        window.location.reload();
    };

    useEffect(() => {
        console.log('history?', history);

        if (history !== undefined) {
            return history.listen((location: any, action: any) => {
                if (action === 'POP') {
                    console.log('just POP!');
                    setValue(convertPath(location.pathname));
                }
            });
        } else {
            return;
        }
    }, [history]);

    useEffect(() => {
        console.log('change value', value);
    }, [value]);

    return (
        <header className={classes.sideHeader}>
            <Box className={classes.logo}>
                <img src="/images/logo_white.png" />
            </Box>
            <Box className={classes.menuBox}>
                <Tabs
                    className={classes.menu}
                    indicatorColor={COLORS.WHITE}
                    orientation="vertical"
                    value={value}
                    onChange={handleChange}
                    aria-label="nav tabs"
                >
                    <LinkTab
                        label="경영현황"
                        classNameProps={classes.linkTab}
                        href={address[0]}
                        history={history}
                        {...a11yProps(0)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="연구개발"
                        href={address[1]}
                        history={history}
                        {...a11yProps(1)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="제품생산"
                        href={address[2]}
                        history={history}
                        {...a11yProps(2)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="재료구매"
                        href={address[3]}
                        history={history}
                        {...a11yProps(3)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="제품판매"
                        href={address[4]}
                        history={history}
                        {...a11yProps(4)}
                    />
                </Tabs>
            </Box>
            <Box className={classes.iconAlignBox}>
                <Box>
                    <IconButton onClick={goQnA}>
                        <img
                            className={classes.IconSize}
                            src="/images/question.png"
                        />
                    </IconButton>
                    <IconButton onClick={goSetting}>
                        <img
                            className={classes.IconSize}
                            src="/images/Settings.webp"
                        />
                    </IconButton>
                    <IconButton onClick={refresh}>
                        <img
                            className={classes.IconSize}
                            src="/images/refresh_white2.png"
                        />
                    </IconButton>
                </Box>
            </Box>
        </header>
    );
};

const d_address = [
    '/CompanyInfo',
    '/MaterialSale',
    '/ProductPurchase',
    '/MaterialList',
    '/ProductList',
];
export const DistributionSideHeader: React.FC<any> = (props) => {
    const classes = useStyles();

    const [value, setValue] = useState(setInitValue(window.location.pathname));
    const history = useHistory();

    const goSetting = () => {
        history.push(`/setting`);
    };

    const goQnA = () => {
        history.push(`/qna`);
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        console.log(newValue);
        setValue(newValue);
    };

    function setInitValue(path: string) {
        if (path == '/') return 0;

        return d_address.findIndex((element) => element == path) || 0;
    }

    const convertPath = (pathName: string) => {
        if (pathName == '/') return 0;
        return address.findIndex((element) => element == pathName);
    };

    const refresh = () => {
        window.location.reload();
    };

    useEffect(() => {
        console.log('history?', history);

        if (history !== undefined) {
            return history.listen((location: any, action: any) => {
                if (action === 'POP') {
                    console.log('just POP!');
                    setValue(convertPath(location.pathname));
                }
            });
        } else {
            return;
        }
    }, [history]);

    useEffect(() => {
        console.log('change value', value);
    }, [value]);

    return (
        <header className={classes.sideHeader}>
            <Box className={classes.logo}>
                <img src="/images/logo_white.png" />
            </Box>
            <Box className={classes.menuBox}>
                <Tabs
                    className={classes.menu}
                    orientation="vertical"
                    indicatorColor={COLORS.WHITE}
                    value={value}
                    onChange={handleChange}
                    aria-label="nav tabs"
                >
                    <LinkTab
                        label="경영현황"
                        classNameProps={classes.linkTab}
                        href={d_address[0]}
                        history={history}
                        {...a11yProps(0)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="재료판매"
                        href={d_address[1]}
                        history={history}
                        {...a11yProps(1)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="제품구매"
                        href={d_address[2]}
                        history={history}
                        {...a11yProps(2)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="보유재료"
                        href={d_address[3]}
                        history={history}
                        {...a11yProps(3)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="보유제품"
                        href={d_address[4]}
                        history={history}
                        {...a11yProps(4)}
                    />
                </Tabs>
            </Box>
            <Box className={classes.iconAlignBox}>
                <Box>
                    <IconButton onClick={goQnA}>
                        <img
                            className={classes.IconSize}
                            src="/images/question.png"
                        />
                    </IconButton>
                    <IconButton onClick={goSetting}>
                        <img
                            className={classes.IconSize}
                            src="/images/Settings.webp"
                        />
                    </IconButton>
                    <IconButton onClick={refresh}>
                        <img
                            className={classes.IconSize}
                            src="/images/refresh_white2.png"
                        />
                    </IconButton>
                </Box>
            </Box>
        </header>
    );
};

const oper_address = [
    '/operation/company/list',
    '/operation/decomposition/appList',
    '/operation/ClassRun',
];
export const OperSideHeader: React.FC<any> = (props) => {
    const classes = useStyles();

    const [value, setValue] = useState(setInitValue(window.location.pathname));
    const { oper } = props;
    const history = useHistory();

    const goSetting = () => {
        history.push(`/setting`);
    };

    const goQnA = () => {
        history.push(`/qna`);
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        console.log(newValue);
        setValue(newValue);
    };

    function setInitValue(path: string) {
        if (path == '/') return 0;

        return address.findIndex((element) => element == path) || 0;
    }

    const convertPath = (pathName: string) => {
        if (pathName == '/') return 0;
        return address.findIndex((element) => element == pathName);
    };

    const refresh = () => {
        window.location.reload();
    };

    useEffect(() => {
        console.log('history?', history);

        if (history !== undefined) {
            return history.listen((location: any, action: any) => {
                if (action === 'POP') {
                    console.log('just POP!');
                    setValue(convertPath(location.pathname));
                }
            });
        } else {
            return;
        }
    }, [history]);

    useEffect(() => {
        console.log('change value', value);
    }, [value]);

    return (
        <header className={classes.sideHeader}>
            <Box className={classes.logo}>
                <img src="/images/logo_white.png" />
            </Box>
            <Box className={classes.menuBox}>
                <Tabs
                    className={classes.menu}
                    indicatorColor={COLORS.WHITE}
                    orientation="vertical"
                    value={value}
                    onChange={handleChange}
                    aria-label="nav tabs"
                >
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="기업리스트"
                        href={oper_address[0]}
                        history={history}
                        {...a11yProps(0)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="분해완료처리"
                        href={oper_address[1]}
                        history={history}
                        {...a11yProps(1)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="랭킹페이지"
                        href={oper_address[2]}
                        history={history}
                        {...a11yProps(2)}
                        member={oper}
                    />
                </Tabs>
            </Box>
            <Box className={classes.iconAlignBox}>
                <Box>
                    <IconButton onClick={goQnA}>
                        <img
                            className={classes.IconSize}
                            src="/images/question.png"
                        />
                    </IconButton>
                    <IconButton onClick={goSetting}>
                        <img
                            className={classes.IconSize}
                            src="/images/Settings.webp"
                        />
                    </IconButton>
                    <IconButton onClick={refresh}>
                        <img
                            className={classes.IconSize}
                            src="/images/refresh_white2.png"
                        />
                    </IconButton>
                </Box>
            </Box>
        </header>
    );
};

export default SideHeader;
